<template>
  <q-badge
    class="c-menu-badge"
    :class="{ 'c-menu-badge--floating': floating }"
    :color
    :text-color="textColor"
    rounded
  >
    {{ label }}
  </q-badge>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label: number | string;
    color?: string;
    textColor?: string;
    floating?: boolean;
  }>(),
  {
    color: "red",
    textColor: "white",
    floating: false,
  },
);
</script>

<style lang="scss" scoped>
.c-menu-badge {
  @apply tw-ml-auto tw-shrink-0 tw-px-1.5 tw-py-0.5 !tw-text-[10px] !tw-leading-none;

  &--floating {
    @apply tw-absolute tw-right-0 tw-top-0 tw-ml-0 !tw-min-h-0 !tw-px-1 !tw-text-[9px];
  }
}
</style>
